import { useEffect, useState } from "react"
import moment from "moment"
import styled from "styled-components"
import { FaEnvelope, FaPlay } from "react-icons/fa"
import { Button } from "@prosolve/common-components-ui"
import Table from "../../shared/Table"
import { checkHasEditJobsPermissions, getEnv } from "../../utils"
import useDataJobs from "../../dataHooks/useDataJobs"
import TestRunModal from "./TestRunModal"
import EventAttendeeCertificateEmailModal from "./EventAttendeeCertificateEmailModal"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 0;
`

const RowGroup = styled.div`
  display: flex;
  gap: 10px;
`

const FlexStart = styled.div`
  display: flex;
  gap: 10px;
  flex: 1;
`

const FlexEnd = styled(FlexStart)`
  justify-content: flex-end;
`

const EmptyMessage = styled.div`
  color: #565656;
  padding: 20px 0px;
`

const ActionsWrapper = styled.div`
  display: flex;
  gap: 5px;
  padding: 8px 0;
  height: 24px;
`

export default ({
  onLoad
}) => {
  const [isShowEmailModal, setIsShowEmailModal] = useState()
  const [isShowTestRunModal, setIsShowTestRunModal] = useState()

  const { isLoading, attendeesForEventCertificates, fetchAttendeesForEventCertificates, fetchRunAttendeeEventCertificateEmail } = useDataJobs()

  const hasEdit = checkHasEditJobsPermissions()
  const isQa = getEnv() === 'qa'

  useEffect(() => {
    fetchAttendeesForEventCertificates()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    onLoad?.(attendeesForEventCertificates)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attendeesForEventCertificates])

  const formatDate = ({ value }) => value ? moment(value).format("MM/DD/YYYY") : ""

  const columns = [
    { headerName: "Attendee", field: "name" },
    { headerName: "Attendee Id", field: "id" },
    { headerName: "Email", field: "email" },
    { headerName: "Event Id", field: "eventId" },
    { headerName: "Event", field: "eventName" },
    { headerName: "Event End", field: "eventEndDate", valueFormatter: formatDate },
    { headerName: "Status", field: "requestStatus" },
    { headerName: "Emails Sent", field: "emailsSent", tooltipField: 'emailsSent' },
    { 
      headerName: 'Actions',
      cellRenderer: ({ data }) => {
        return (
          <ActionsWrapper>
            <Button onClick={() => setIsShowEmailModal({ attendeeForEvent: data })}><FaEnvelope /></Button>
            <Button onClick={() => handleTestRunModal({ attendeeId: data.id })}><FaPlay /><span>*</span></Button>
            {!isQa &&
              <Button onClick={() => handleRun({ attendeeId: data.id })}><FaPlay /></Button>
            }
          </ActionsWrapper>
        )
      }
    },
  ]

  const handleShowEmailExample = () => {
    setIsShowEmailModal({
      attendeeForEvent: {
        name: '[Example Attendee Name]',
        email: '[Email@mail.com]',
        eventId: '[12345]',
        eventName: '[Example Event Name]',
        eventStartDate: '2019-03-18'
      }
    })
  }

  const handleTestRunModal = (props) => {
    setIsShowTestRunModal({ data: props })
  }

  const handleTestRun = (props) => {
    fetchRunAttendeeEventCertificateEmail(props)
  }

  const handleRun = ({ attendeeId }) => {
    if (window.confirm('Please confirm you want to run this process. Emails will be sent out to users.')) {
      fetchRunAttendeeEventCertificateEmail({ attendeeId })
    }
  }

  return (
    <Container>
      <RowGroup>
        <Button onClick={handleShowEmailExample} style={{ width: '200px' }}>
          <FaEnvelope style={{ paddingRight: '5px' }} />
          Example Email
        </Button>

        {hasEdit &&
        <>
          <FlexEnd>
            <Button onClick={() => handleTestRunModal()} style={{ width: '200px' }}>
              <FaPlay /><span style={{ paddingRight: '5px' }}>*</span>
              Test Run
            </Button>
            
            {!isQa &&
              <Button onClick={handleRun} style={{ width: '200px' }}>
                <FaPlay style={{ paddingRight: '5px' }} />
                Manual Run
              </Button>
            }
          </FlexEnd>
        </>
        }
      </RowGroup>

      {
        (attendeesForEventCertificates || []).length > 0 || isLoading
          ? (
            <Table
              data={attendeesForEventCertificates}
              cols={columns}
              isLoading={isLoading}
            />
          )
          : <EmptyMessage>No reminders found.</EmptyMessage>
      }

      {isShowEmailModal &&
        <EventAttendeeCertificateEmailModal {...isShowEmailModal} onClose={() => setIsShowEmailModal()} />
      }
      
      {isShowTestRunModal &&
        <TestRunModal {...isShowTestRunModal} onClose={() => setIsShowTestRunModal()} onSuccess={handleTestRun} />
      }
    </Container>
  )
}
